export const _sharedActionsConstantsSupport = {
  FETCH_CF: "support/FETCH_CF",
  SEND_CF: "support/SEND_CF",
  FETCH_CF_SUCCESS: "support/FETCH_CF_SUCCESS",
  SEND_CF_STATUS: "support/SEND_CF_STATUS",
};

export const _sharedActionsSupport = {
  actionFetchCF: () => ({
    type: _sharedActionsConstantsSupport.FETCH_CF,
  }),
  actionSendCF: (data) => ({
    type: _sharedActionsConstantsSupport.SEND_CF,
    data,
  }),
  actionFetchCFSuccess: (data) => ({
    type: _sharedActionsConstantsSupport.FETCH_CF_SUCCESS,
    data,
  }),
  actionSendCFStatus: (data) => ({
    type: _sharedActionsConstantsSupport.SEND_CF_STATUS,
    data,
  }),
};
